import {propertyInstructionMapper} from "./propertyInstructionMapper";

export const homeMapper = (data) => {
    return {
        id: data.id,
        name: data.name,
        mail: data.mail,
        addressStreet: data.addressStreet,
        addressNumber: data.addressNumber,
        mobilePhone: data.mobilePhone,
        phone: data.phone,
        cirCode: data.cirCode,
        cinCode: data.cinCode,
        cinCodeMissing: data.cinCodeMissing,
        icon: data.icon,
        category: data.category,
        arrivalDay: data.arrivalDay,
        url: data.url,

        // Cut out the time zone. This way the time received by the server is considered as local time.
        checkIn: data.checkIn ? new Date(data.checkIn.substring(0, 19)) : null,
        checkOut: data.checkOut ? new Date(data.checkOut.substring(0, 19)) : null,

        visible: data.visible,
        descriptionIt: data.descriptionIt,
        descriptionEn: data.descriptionEn,

        position: {
            latitude: data.position?.latitude,
            longitude: data.position?.longitude,
        },

        locationId: data.locationId,

        // List of apartments
        apartments: data.apartments ? data.apartments.map(apartmentMapper) : [],

        // List of photos
        photos: data.homePhotos ? data.homePhotos.map(homePhotoMapper) : [],

        // List of services
        serviceJoins: data.homeServiceJoins ? data.homeServiceJoins.map(homeServiceJoinMapper) : [],

        // List of property instructions
        propertyInstructions: data.propertyInstructions ? data.propertyInstructions.map(propertyInstructionMapper) : [],
    }
}

export const apartmentMapper = (data) => {
    return {
        id: data.id,
        name: data.name,
        icon: data.icon,
        mq: data.mq,
        beds: data.beds,
        sofaBeds: data.sofaBeds,
        extraBeds: data.extraBeds,
    }
}

export const homePhotoMapper = (data) => {
    return {
        id: data.id,
        orderPosition: data.orderPosition,
        imgSquare: data.imgSquare,
    }
}

export const homeServiceJoinMapper = (data) => {
    return {
        id: data.id,
        homeServiceId: data.homeServiceId,
        withFee: data.withFee,
    }
}